import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { Subject } from 'rxjs';
import { classToPlain } from 'class-transformer';
// devextreme imports
import { custom } from 'devextreme/ui/dialog';
// cc-common imports
import { CCLocalStorageCategory, CCLocalStorageService, Utils } from 'cc-common';
// service imports
import { UserService } from '../data-services/user.service';
import { AuthService } from '../auth.service';
import { ServerErrorService } from './server-error.service';
import { HelperService } from './helper.service';
import { ContextManagerService } from '../data-services/context-manager.service';
import { ActionAccessListParameterDto } from '../../_models/action-access-list-parameter-dto';
// constants imports
import { EmailConstants } from '../../_constants/email-constants';
import { StorageKeyConstants } from '../../_constants/storage-key-constants';
import { URLConstants } from '../../_constants/url-constants';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import * as i0 from "@angular/core";
import * as i1 from "../data-services/user.service";
import * as i2 from "./server-error.service";
import * as i3 from "./helper.service";
import * as i4 from "cc-common";
import * as i5 from "@angular/common/http";
import * as i6 from "../auth.service";
import * as i7 from "../data-services/context-manager.service";
export class EmailSharedService {
    constructor(userService, errorService, helperService, localStorageService, httpClient, authService, contextManagerService) {
        this.userService = userService;
        this.errorService = errorService;
        this.helperService = helperService;
        this.localStorageService = localStorageService;
        this.httpClient = httpClient;
        this.authService = authService;
        this.contextManagerService = contextManagerService;
        this._subjectTranferEmail = new Subject();
        this._subjectSetEmailStatus = new Subject();
        this._subjectEmailMoveTo = new Subject();
        this._subjectSetEmailPriority = new Subject();
        this._subjectEmailAssignedTo = new Subject();
        this._subjectUpdateFolder = new Subject();
        this._subjectForceRefresh = new Subject();
        this._subjectForceRepaint = new Subject();
        this._subjectChangesInCiramailPreferences = new Subject();
        this._subjectFreezeEmailAction = new Subject();
    }
    get windowSize() {
        return this.localStorageService.getItem(StorageKeyConstants.emailWindowSize, CCLocalStorageCategory.PREF)
            ? JSON.parse(this.localStorageService.getItem(StorageKeyConstants.emailWindowSize, CCLocalStorageCategory.PREF))
            : EmailConstants.WINDOW_SIZE_PERCENT;
    }
    get windowWidth() {
        // 25% => windowSize = 0.25;
        return Math.ceil(screen.width * this.windowSize);
    }
    get windowHeight() {
        // 25% => windowSize = 0.25;
        return Math.ceil(screen.height * this.windowSize);
    }
    emailComposer(emailAccount, composeMode = 'NEW', emailCacheId = null, communityId = null, customerId = null, recipients = [], emailFolder = null) {
        const params = [`composeMode=${composeMode}`];
        if (Utils.notNullOrEmpty(emailAccount)) {
            params.push(`emailAccount=${emailAccount}`);
        }
        if (Utils.notNullOrEmpty(emailCacheId)) {
            params.push(`emailCacheId=${emailCacheId}`);
        }
        if (Utils.notNullOrEmpty(communityId)) {
            params.push(`communityId=${communityId}`);
        }
        if (Utils.notNullOrEmpty(customerId)) {
            params.push(`customerId=${customerId}`);
        }
        if (Utils.notNullOrEmpty(recipients)) {
            params.push(`recipients=${recipients.join(';')}`);
        }
        if (Utils.notNullOrEmpty(emailFolder)) {
            params.push(`emailFolder=${emailFolder}`);
        }
        const url = `ciramail/compose-email?${params.join('&')}`;
        return window.open(url, '_blank', `scrollbars=1,width=${this.windowWidth},height=${this.windowHeight}`);
    }
    emailComposerForOwnerCollectionStatus(communityId, customerId) {
        const userId = this.userService.getCurrentUserId();
        let url = `ciramail/compose-email?currentUserId=${userId}&communityId=${communityId}`;
        url += customerId ? `&customerId=${customerId}` : ``;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    emailComposerForEmailAccStatement(baseParams) {
        let url = `ciramail/compose-email?beginDate=${dateJSONTransformer(baseParams.beginDate)}&endDate=${dateJSONTransformer(baseParams.endDate)}&communityId=${baseParams.communityId}`;
        url += baseParams.customerId ? `&customerId=${baseParams.customerId}` : ``;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    emailComposerWithDocument(communityId, customerId, fileId) {
        let url = `ciramail/compose-email?communityId=${communityId}&fileId=${fileId}`;
        url += customerId ? `&customerId=${customerId}` : ``;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    emailComposerForInternalTask(communityId, taskId) {
        const url = `ciramail/compose-email?communityId=${communityId}&internalTaskId=${taskId}&composeMode=NEW`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    emailComposerForProjectTask(communityId, taskId) {
        const url = `ciramail/compose-email?communityId=${communityId}&projectTaskId=${taskId}&composeMode=NEW`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    emailComposerForWorkOrder(communityId, workOrderId, workOrderProposalId = null) {
        let url = `ciramail/compose-email?communityId=${communityId}&workOrderId=${workOrderId}`;
        if (Utils.notNullOrEmpty(workOrderProposalId)) {
            url += `&workOrderProposalId=${workOrderProposalId}`;
        }
        url += `&composeMode=NEW`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    emailComposerForProcessTracker(processName, processGuid) {
        const tokens = [`processName=${processName}`, `processGuid=${processGuid}`];
        const url = `ciramail/compose-email?${tokens.join('&')}`;
        return window.open(url, '_blank', `scrollbars=1,width=${this.windowWidth},height=${this.windowHeight}`);
    }
    emailComposerForBoardCommitteeMembers(emailAccount, composeMode = EmailConstants.BOARD_MEMBER, emailCacheId = null, communityId = null, customerId = null, recipients = [], communityExecutiveIds = null) {
        const params = [`composeMode=${composeMode}`];
        if (Utils.notNullOrEmpty(emailAccount)) {
            params.push(`emailAccount=${emailAccount}`);
        }
        if (Utils.notNullOrEmpty(emailCacheId)) {
            params.push(`emailCacheId=${emailCacheId}`);
        }
        if (Utils.notNullOrEmpty(communityId)) {
            params.push(`communityId=${communityId}`);
        }
        if (Utils.notNullOrEmpty(customerId)) {
            params.push(`customerId=${customerId}`);
        }
        if (Utils.notNullOrEmpty(recipients)) {
            params.push(`recipients=${recipients.join(';')}`);
        }
        if (Utils.notNullOrEmpty(communityExecutiveIds)) {
            params.push(`communityExecutiveIds=${JSON.stringify(communityExecutiveIds)}`);
        }
        const url = `ciramail/compose-email?${params.join('&')}`;
        return window.open(url, '_blank', `scrollbars=1,width=${this.windowWidth},height=${this.windowHeight}`);
    }
    emailComposerForVendorManagement(contextVendorId, contextId) {
        let url = `ciramail/compose-email?contextVendorId=${contextVendorId}&contextId=${contextId}`;
        url += `&composeMode=NEW`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    openEmailViewer(emailCacheId, emailAccount, folder) {
        const queryParam = `?emailId=${emailCacheId}&accountName=${emailAccount}&folderName=${folder}`;
        this.openEmailViewerWithQueryParam(queryParam);
    }
    openEmailViewerWithQueryParam(queryParam) {
        const baseParams = new ActionAccessListParameterDto();
        this.userService.getActionList(baseParams).subscribe((results) => {
            const accessFound = results.find((d) => Utils.equalsIgnoreCase(d.code, 'EMAIL'));
            if (Utils.notNullAndDefined(accessFound)) {
                // This functionality is different from V1. In V2 if User has access to the Email, readingPane toolbar Actions and email attribution will be shown in the Email Viewer.
                const url = `ciramail/view-email${queryParam}`;
                this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight);
            }
            else {
                // If User don't have access to the Email, then actions will not be available, only plain email text like V1 is shown.
                const url = `cira-view-email${queryParam}`;
                this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight);
            }
        }, (error) => {
            this.errorService.displayError(error);
        });
    }
    unlockEmail(params) {
        const url = `${URLConstants.ccEmailApiBaseUrl}/unlock`;
        return this.httpClient.put(url, classToPlain(params));
    }
    openPrintableView(emailCacheId, emailAccount) {
        const url = `ciramail/print-email?emailCacheId=${emailCacheId}&emailAccount=${emailAccount}`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight);
    }
    openMassCommunicationEmailViewer(jobId, communityId) {
        const url = `community/${communityId}/job-viewer?jobId=${jobId}`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight);
    }
    onForceReload() {
        this._subjectForceRefresh.next(true);
    }
    forceReload() {
        return this._subjectForceRefresh;
    }
    onForceRepaint() {
        this._subjectForceRepaint.next(true);
    }
    forceRepaint() {
        return this._subjectForceRepaint;
    }
    onFreezeEmailAction(id) {
        this._subjectFreezeEmailAction.next(id);
    }
    freezeEmailActions() {
        return this._subjectFreezeEmailAction;
    }
    transferEmail(emailAccount, popoverTarget, selectedEmailCacheIds, communityId = null) {
        this._subjectTranferEmail.next({
            emailAccount,
            popoverTarget,
            selectedEmailCacheIds,
            communityId
        });
    }
    onTransferEmail() {
        return this._subjectTranferEmail;
    }
    setStatus(emailAccount, popoverTarget, selectedEmailCacheIds, folderName) {
        this._subjectSetEmailStatus.next({
            emailAccount,
            popoverTarget,
            selectedEmailCacheIds,
            folderName
        });
    }
    onSetStatus() {
        return this._subjectSetEmailStatus;
    }
    moveEmailTo(emailAccount, popoverTarget, selectedEmailCacheIds, folderName) {
        this._subjectEmailMoveTo.next({
            emailAccount,
            popoverTarget,
            selectedEmailCacheIds,
            folderName
        });
    }
    onMoveEmailTo() {
        return this._subjectEmailMoveTo;
    }
    setPriority(emailAccount, popoverTarget, selectedEmailCacheIds, folderName) {
        this._subjectSetEmailPriority.next({ emailAccount, popoverTarget, selectedEmailCacheIds, folderName });
    }
    onSetPriority() {
        return this._subjectSetEmailPriority;
    }
    setAssignedTo(emailAccount, popoverTarget, selectedEmailCacheIds, folderName) {
        this._subjectEmailAssignedTo.next({ emailAccount, popoverTarget, selectedEmailCacheIds, folderName });
    }
    onSetAssignedTo() {
        return this._subjectEmailAssignedTo;
    }
    markEmailAsComplete(emailAccount, sourceFolder, emailCacheId) {
        const currentUserId = this.userService.getCurrentUserId();
        if (Utils.notNullOrEmpty(currentUserId)) {
            const storageKey = this.userService.getUserStorageKey(currentUserId, `${StorageKeyConstants.emailSentKey}_${emailCacheId}`, CCLocalStorageCategory.EMAIL);
            const emailSuccess = localStorage.getItem(storageKey);
            if (Utils.equalsIgnoreCase(sourceFolder, EmailConstants.INBOX) &&
                Utils.equalsIgnoreCase(emailSuccess, EmailConstants.EMAIL_SENT_STATUS_SUCCESS)) {
                localStorage.removeItem(storageKey);
                const customDialog = custom({
                    title: 'Confirmation',
                    messageHtml: `Email sent successfully! Do you want to mark this email as 'Complete'?`,
                    buttons: [
                        {
                            text: 'Yes',
                            type: 'success',
                            onClick: (e) => {
                                this.updateFolder(emailAccount, sourceFolder, EmailConstants.COMPLETED, [emailCacheId]);
                            }
                        },
                        {
                            text: 'No',
                            type: 'default',
                            onClick: (e) => {
                                return true;
                            }
                        }
                    ]
                });
                customDialog.show();
            }
        }
        else {
            const customDialog = custom({
                title: 'Session Ended',
                messageHtml: `Your session has expired. Please log in again to continue.`,
                buttons: [
                    {
                        text: 'Ok',
                        hint: 'Ok',
                        type: 'default',
                        onClick: () => {
                            this.authService.logOut();
                            this.contextManagerService.updateContext(null); // reset context once logout
                        }
                    }
                ]
            });
            customDialog.show();
        }
    }
    updateFolder(emailAccount, sourceFolder, targetFolder, selectedEmailCacheIds) {
        this._subjectUpdateFolder.next({ emailAccount, sourceFolder, targetFolder, selectedEmailCacheIds });
    }
    onUpdateFolder() {
        return this._subjectUpdateFolder;
    }
    isOpenNotesOnLoad() {
        return JSON.parse(this.localStorageService.getItem(StorageKeyConstants.ciramailNotesKey, CCLocalStorageCategory.PREF));
    }
    getCiramailPreferences() {
        return this._subjectChangesInCiramailPreferences;
    }
    updateCiramailPreferences(state) {
        this._subjectChangesInCiramailPreferences.next(state);
    }
    emailComposerForAcc(communityId, customerId, accItemId) {
        const url = `ciramail/compose-email?communityId=${communityId}&customerId=${customerId}&accItemId=${accItemId}&composeMode=NEW`;
        this.helperService.openWindow(url, '_blank', this.windowWidth, this.windowHeight, true);
    }
    getAddressString(address) {
        const addressTokens = [];
        if (Utils.notNullOrEmpty(address)) {
            address.forEach((addr) => {
                if (Utils.notNullOrEmpty(addr.email)) {
                    addressTokens.push(addr.email);
                }
            });
        }
        return addressTokens.join('; ');
    }
    printEmailContent(htmlContent) {
        this.helperService.openWindowWithContent('_blank', this.windowWidth, this.windowHeight, true, htmlContent);
    }
}
EmailSharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EmailSharedService_Factory() { return new EmailSharedService(i0.ɵɵinject(i1.UserService), i0.ɵɵinject(i2.ServerErrorService), i0.ɵɵinject(i3.HelperService), i0.ɵɵinject(i4.CCLocalStorageService), i0.ɵɵinject(i5.HttpClient), i0.ɵɵinject(i6.AuthService), i0.ɵɵinject(i7.ContextManagerService)); }, token: EmailSharedService, providedIn: "root" });
